<template>
    <div id="pageHome">
		<div class="container">
			<div class="hoya"><img src="img/hoya.png" alt="HOYA" class="img-responsive"/></div>
			<h1><i>2017</i> Global Leadership <span>Group Meeting</span> <b>Beijing</b></h1>
			<div class="content">            
				<p class="eventStart"><b>Registration Starts</b> <i>10 November 2016</i></p>
				<p class="eventEnd"><b>Registration Ends</b> <i>10 February 2017</i></p>
				<footer><router-link to="/information" class="btn btn-primary">Proceed to Register</router-link></footer>
			</div>
		</div>
        <!-- <b-container id="pageHome" class="page" fluid>	  
            <b-row align-v="center">
                <b-col sm="12" >
                    <div class="container">
                        <div class="hoya"><img src="/img/hoya.png" alt="HOYA" class="img-responsive"/></div>
                        <h1><i>2017</i> Global Leadership <span>Group Meeting</span> <b>Beijing</b></h1>
                        <div class="content">            
                            <p class="eventStart"><b>Registration Starts</b> <i>10 November 2016</i></p>
                            <p class="eventEnd"><b>Registration Ends</b> <i>10 February 2017</i></p>
                            <footer><router-link to="/information" class="btn btn-primary">Proceed to Register</router-link></footer>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>page ends -->
    </div>
</template>

<script>
export default {
    name: 'Home'
}
</script>

<style lang="less" scoped>
#pageHome {  
	display: flex;
	flex-direction: column;
	height: 100%;
	justify-content: center;

    .container {
		.boxPadding;
		
        
    }
	.content {
        .RoundedShape(5px);
				
		background: lighten(@blue,45);
        margin: 0 auto 1.5em;
        padding-top: 15px;
		position: relative;
		width:  300px;
		z-index:1;
	}
	.hoya {
		.Position(relative,0,0,0,0);
		margin: 0 auto 30px;
		height: 118px;
		width: 234px;
		z-index: 1;
	}
	h1 {
		.TextShadow(0,4px,0,darken(@blue,10) );
		color: #fff;
		font-size: 2.125em;
		line-height: 1.3em;
		margin-bottom: 30px;
		position: relative;
		text-align: center;
		z-index: 1;
		
		i {
			display: block;
			font-size: 1.714em;
			font-style: normal;
			margin-bottom:0.20em;
		}
		
		b {			
			display: block;
			font-size: 1.714em;
			line-height: 1.20em;
		}
		span {
			display: block;
		}
	}
    p {		
		color: #fff;
        text-align:center;	
		
		b {			
			.title;
			color: @blue;
			border-bottom: 1px dashed @blue;
			display: inline-block;
			margin-bottom: 0.3em;
			padding-bottom:  0.3em;
			font-size: ;
		}
		i {
			display: block;
			font-style: normal;
		}
    }
    footer {
		margin: 0;
		padding: 0;		
	}
	.btn {
		.RoundedShapeCustom(0px,0px,3px,3px);
		color: #fff;
		font-size:1.188em;
		padding-top: 0.8em;
		padding-bottom: 0.8em;
		text-transform:uppercase;
        width: 100%;
        
        
	}
}
</style>